import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
    selector: 'unified-ui-warning-overlay',
    standalone: true,
    imports: [],
    templateUrl: './warning-overlay.component.html',
    styleUrl: './warning-overlay.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WarningOverlayComponent {
    public readonly isError = input<boolean>(false);
}
